import React from 'react';

interface WhiskIconProps {
  className?: string;
}

export function WhiskIcon({ className = "" }: WhiskIconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
    >
      <defs>
        <filter id="glow">
          <feGaussianBlur stdDeviation="0.5" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
        
        {/* Animation path for the whisk wires */}
        <path
          id="whiskPath"
          d="M12,12 m-8,0 a8,8 0 1,0 16,0 a8,8 0 1,0 -16,0"
          fill="none"
        />
      </defs>

      {/* Main whisk shape */}
      <g
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        filter="url(#glow)"
        className="origin-center"
      >
        {/* Handle */}
        <path 
          d="M12 3v8" 
          className="origin-bottom"
        />
        
        {/* Whisk wires with animation */}
        <g className="origin-center animate-[spin_4s_linear_infinite]">
          {/* First set of wires */}
          <path d="M8 11c0,3 1,5 4,5 3,0 4,-2 4,-5" />
          <path d="M7 13c0,3.5 2,6 5,6 3,0 5,-2.5 5,-6" />
          
          {/* Second set of wires (perpendicular) */}
          <path d="M8 11c0,-3 1,-5 4,-5 3,0 4,2 4,5" />
          <path d="M7 13c0,-3.5 2,-6 5,-6 3,0 5,2.5 5,6" />
        </g>

        {/* Connecting point */}
        <circle
          cx="12"
          cy="11"
          r="1"
          fill="currentColor"
          className="animate-pulse"
        />
      </g>

      {/* Sparkle effects */}
      <g className="animate-ping opacity-50">
        <circle cx="12" cy="7" r="0.5" fill="currentColor" />
        <circle cx="15" cy="11" r="0.5" fill="currentColor" />
        <circle cx="9" cy="11" r="0.5" fill="currentColor" />
      </g>
    </svg>
  );
}